import { SelectOptions } from 'app/area/code-selector/types';
import { SimpleFormAreaState } from 'app/infrastructure/simple-form/types';
import { FavouriteDefinition, TextCollection } from 'app/types-shared';

export interface SavedReportState {
  fetching: boolean;
  fetchingCreateFolder: boolean;
  fetchingFolder: boolean;
  folderDefinition: FavouriteDefinition;
  error: boolean;
  texts: TextCollection;
  simpleForm?: SimpleFormAreaState;
  validation: any;
  reports: SelectOptions;
  searchRequiredUsers: boolean;
  bookmarkedReports: SelectOptions;
  viewMode?: ViewMode;
  viewModeCompanyReport?: ViewMode;
  viewModeDashboard?: ViewMode;
}

export enum ViewMode {
  allReports,
  bookmarkedReports
}
